import { useEffect } from "react";
import { ThreePlanogram } from "../../store/types";
import { PlanogramBay } from "@CommonTypes/merchflow/pog/bay";
import { createThreeMesh } from "../../store/utils/three";
import { Color } from "src/elements";
import { useSplitShift } from "../../store/splitShift";

interface Props {
  bay: PlanogramBay;
  bayIndex: number;
  three: ThreePlanogram;
}

export const BayVerticalLine = ({ bay, bayIndex, three }: Props) => {
  const toSceneX = useSplitShift();

  useEffect(() => {
    const dividerWidth = 100;
    const dividerX = toSceneX(bay.getXLeft()) + bay.width - dividerWidth / 2;

    const dashHeight = 200;
    const dashGap = 200;

    const totalHeight = bay.height;
    const dashCount = Math.floor(totalHeight / (dashHeight + dashGap));

    const dashCleanups: Array<() => void> = [];

    // A pallet under a gondola bay takes no width along the run: it is not a
    // bay to the right of this one.
    const hasBayToTheRight = bay.planogram.bays
      .slice(bayIndex + 1)
      .some((other) => !other.getBayAbove());

    // A bay the run breaks after gets the aisle break instead of a seam line.
    if (hasBayToTheRight && !bay.splitAfter) {
      for (let dashIndex = 0; dashIndex < dashCount; dashIndex++) {
        const dashY = dashIndex * (dashHeight + dashGap) + dashHeight / 2;

        const dash = createThreeMesh({
          scene: three.scene,
          width: dividerWidth,
          height: dashHeight,
          depth: bay.depth,
          x: dividerX,
          y: dashY,
          z: 0,
          color: Color.forest950,
          renderOrder: 3,
        });

        dashCleanups.push(dash.cleanUp);
      }
    }

    return () => {
      dashCleanups.forEach((fn) => fn());
    };
  }, [bay, bayIndex, three, toSceneX]);

  return null;
};
